import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import "./restaurant-list.scss";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import SearchField from "../../components/search-field/search-field";
import HotelCard from "../../components/hotel-card/hotel-card";
import Loader from "../../components/loader/loader";
import Lottie from "lottie-react";
import NotFound from "../../assets/NotFound.json";
import Image from "../../components/image/image";
import { handlePaybillOutletName } from "../../utils";
import { TwoBtnModal } from "../../components/modal/modal";

import { walletAmount } from "../../store/wallet/walletSlice";
import TokenValidationAPI from "../../services/TokenValidation/TokenValidation";
import { GetDineInOutletsListAPI, GetDineInOutletsAPI} from "../../services/GetDineInOutlets/GetDineInOutlets";
import GetRestaurantsCategoryAPI from "../../services/GetRestaurantsCategory/GetRestaurantsCategory";
import GetWalletPointsAPI from "../../services/GetWalletPoints/GetWalletPoints";
import GetSearchOutletAPI from "../../services/GetSearchOutletList/GetSearchOutletList";
import UserTraction from "../../services/UserTraction/UserTraction";
import GetPwaToken from "../../services/GetPwaToken/GetPwaToken";
import { updateHeaders } from "../../services/apiConstants";

const style = {
  height: 300, //Style for lottie animation
};

const RestaurantList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoader, setIsLoader] = useState(true);
  const [restaurantList, setRestaurantList] = useState([]);
  const [cityName, setCityName] = useState("");
  const [localityName, setLocalityName] = useState("");
  const [walletPoints, setWalletPoints] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal for exit application
  const [hasScrolled, setHasScrolled] = useState(() => {return sessionStorage.getItem("hasScrolled") === "true"}); // Track if user has scrolled
  const [searchTimeout, setSearchTimeout] = useState(null);

  useEffect(() => {
    window.history.pushState(null, '', '/outlet-list'); 
    window.addEventListener('popstate', handleBack);
    return () => {
      window.removeEventListener('popstate', handleBack);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasScrolled) {
        setHasScrolled(true);
        sessionStorage.setItem("hasScrolled", "true");
        callScrollApi(); // Call API when user scrolls for the first time
      }
    };

    const callScrollApi = async () => {
      let EventNo = 1;
      try {
        const response = await UserTraction({
          EventNo: EventNo
        });
      } catch (error) {
        console.error('API error:', error);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  },[hasScrolled])
  
  useEffect(() => {
    // let urlTokenParams = searchParams.get("token");
    // let tokenOnly = urlTokenParams;
    // let promoCode = null;
    // let sourcePWA = "";
    // if (urlTokenParams) {
    //   [tokenOnly, promoCode, sourcePWA] = urlTokenParams.split('/');
    //   sessionStorage.setItem("token", tokenOnly);
    //   sessionStorage.setItem("sourcePWA", sourcePWA);
    //   updateHeaders(tokenOnly);
    //   if (promoCode) {
    //     let outletId = 0;
    //     sessionStorage.setItem("promoOutletID", outletId);
    //     sessionStorage.setItem("promoCode", promoCode);
    //   }
    // } 
    let urlTokenParams = searchParams.get("token");
    let tokenOnly = "";
    let promoCode = null;
    let defaultPWA = "";

    if (urlTokenParams) {
      const parts = urlTokenParams.split('/');

      tokenOnly = parts[0];
      
      // Check if second part exists
      if (parts[1]) {
        if (parts[1].startsWith("default")) {
          defaultPWA = parts[1];
        } else {
          promoCode = parts[1];
        }
      }

      // If there's a third part, it will always be defaultPWA
      if (parts[2]) {
        defaultPWA = parts[2];
      }

      sessionStorage.setItem("token", tokenOnly);
      sessionStorage.setItem("defaultPWA", defaultPWA);
      updateHeaders(tokenOnly);

      if (promoCode) {
        let outletId = 0;
        sessionStorage.setItem("promoOutletID", outletId);
        sessionStorage.setItem("promoCode", promoCode);
      }
    } else {
      urlTokenParams = sessionStorage.getItem("token");
    }
    let isExitParams = searchParams.get("isExit");
    isExitParams && sessionStorage.setItem("isExit", isExitParams);
    if (!isExitParams) {
      isExitParams = sessionStorage.getItem("isExit");
    }

    let passedCustomerId = searchParams.get("custID");
    let passedBankName = searchParams.get("bankName");
    let passedOutletID = searchParams.get("outletID");
    if(passedCustomerId && passedBankName){
      if(passedOutletID){
        getToken(passedCustomerId, passedBankName);
      }else{
        getToken(passedCustomerId, passedBankName);
      }
    }else{
      tokenValidate();
      getWalletPoints();
    }
  }, []);

  const tokenValidate = async (token) => {
    setCityName(sessionStorage.getItem("city"));
    setLocalityName(sessionStorage.getItem("locality"));
    try {
      const responseData = await TokenValidationAPI(token);
      if (responseData) {
        sessionStorage.setItem('customerID',responseData?.chegcustomerId);
        sessionStorage.setItem('bankName',responseData?.bankName);
        const getCity = sessionStorage.getItem("city");
        const getLocality = sessionStorage.getItem("locality");
        const storedCity = sessionStorage.getItem("apiCityValue");
        const storedLocality = sessionStorage.getItem("apiLocalityValue");
        const storedRestoList = sessionStorage.getItem("storedRestoList");
        const storedRestoType = sessionStorage.getItem("storedRestoType");
        if(storedCity && storedLocality && getCity && getLocality && getLocality === storedLocality && getCity === storedCity && storedRestoList && storedRestoType){
          setRestaurantList(JSON.parse(storedRestoList))
          setIsLoader(false)
          // setRestaurantType(JSON.parse(storedRestoType))
        }else{
          getRestaurantList();
          getRestaurantCategories();
        }
      }
    } catch (error) {
      console.log("tokenValidate---", error);
    }
  };

  const getToken = async (cutomerID, bankName) => {
    try{
      const response = await GetPwaToken(cutomerID, bankName);
      if(response && response?.success){
        sessionStorage.setItem('customerID',cutomerID);
        sessionStorage.setItem('bankName',bankName);
        sessionStorage.setItem("token", response?.data?.token);
        tokenValidate(response?.data?.token);
      }
    }catch(e){
      console.log("Error while calling GetPwaToken API :",e);
    }
  }

  const getWalletPoints = async () => {
    try {
      const responseData = await GetWalletPointsAPI();
      setWalletPoints(responseData?.walletPoints);
      dispatch(walletAmount(responseData?.walletPoints));
      // let points = 1851;
      // setWalletPoints(points);
      // dispatch(walletAmount(points));
    } catch (error) {
      console.log("wallet points---", error);
    }
  };

  const getRestaurantList = useCallback(async () => {
    setIsLoader(true);
    const cityValue = sessionStorage.getItem("city") || '';
    const localityValue = sessionStorage.getItem("locality") || '';
    const localityData = sessionStorage.getItem("localityValue") || '';
    try {
      const restaurantData = await GetDineInOutletsAPI(localityData);
      setRestaurantList(restaurantData);
      if(restaurantData){
        sessionStorage.setItem("apiCityValue",cityValue);
        sessionStorage.setItem("apiLocalityValue",localityValue);
        sessionStorage.setItem("storedRestoList",JSON.stringify(restaurantData));
      }
      setIsLoader(false);
    } catch (error) {
      console.log("Error fetching resto data :",error);
    }
  }, []);

  const getRestaurantCategories = useCallback(async () => {
    try {
      const responseData = await GetRestaurantsCategoryAPI();
      if(responseData) {
        sessionStorage.setItem("storedRestoType",JSON.stringify(responseData))
      }
    } catch (error) {
      console.log("category type---", error);
    }
  },[]);

  const handleRestaurantDetail = (outlet) => {
    localStorage.setItem("outletDetailsInfo", JSON.stringify(outlet));
    sessionStorage.setItem("payBillSource","restaurantList")
    navigate("/pay-bill", {
      state: { outletId: outlet.outletId },
    });
  };

  const onLocationChange = () => {
    // navigate("/search-city");
    sessionStorage.setItem("fromPage","listing");
    navigate("/search-location");
  };

  const handleBack = () => {
    //navigate("/explore");
    setIsModalOpen(true)
  }

  const handleOk = () => {
    // const exitType = sessionStorage.getItem('isExit');
    const defaultPWA = sessionStorage.getItem('defaultPWA')||"";
    // if(exitType){
    //   navigate('/exitpwa?isExit=bank')
    // }else{
      if(defaultPWA){
        // const PWA_URL = "https://scratchcardpwasg.z29.web.core.windows.net";
        // const link = `<click>https://click.cheggout.com/?type=pwa&id=${PWA_URL}?token=tokenvalue/defaultPage=true</click>`;
        // const encodedlink = btoa(link);
        // navigate(`/exitpwa?launch=${encodedlink}`)
        navigate('/backpwa')
      }else{
        navigate('/exitpwa')
      }
    // }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    return
  }

  const onSearchOutlet = (e) => {
    const searchQuery = e.target.value;
    setSearchQuery(searchQuery);  // Update the search query state
  
    if (searchTimeout) {
      clearTimeout(searchTimeout);  // Clear the previous timeout if the user types again
    }
  
    // Set a new timeout to trigger the API call after 3 seconds of no typing
    setSearchTimeout(
      setTimeout(() => {
        if(searchQuery!=""){
          userSearchTraction(searchQuery);  // Call the search tracking function after 3 seconds
        }
      }, 3000)
    );
  }

  const userSearchTraction = async (searchedOutlet) => {
    let EventNo = 4;
    try {
      const response = await UserTraction({
        EventNo: EventNo,
        SearchText: searchedOutlet
      });
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const filteredRestaurants = restaurantList.filter((restaurant) =>
    restaurant.outletName.toLowerCase().includes(searchQuery.toLowerCase()) || restaurant.locality.toLowerCase().includes(searchQuery.toLowerCase()) 
  );

  return (
    <div className="paybill-page">
      {isLoader && <Loader />}
      <div className="top-section">
        <Header
          coin={walletPoints}
          city={cityName}
          location={localityName}
          locationChange={onLocationChange}
          onClick={handleBack}
          exitButton={true}
        />
        <SearchField onChange={onSearchOutlet}/>
      </div>
      {filteredRestaurants?.length >= 1 && (
        <div className="hotel-section">
          {filteredRestaurants?.map((outlet, index) => {
            return (
              <span key={index}>
                <HotelCard
                  imgSrc={outlet?.outletMedias[0]?.mediaPath}
                  // name={handlePaybillOutletName(outlet?.outletName)}
                  name={outlet?.outletName}
                  place={outlet?.locality}
                  offer={outlet?.outletOffers[0]}
                  onClick={() => handleRestaurantDetail(outlet)}
                />
              </span>
            );
          })}
        </div>
      )}
      {!isLoader & (filteredRestaurants?.length === 0) ? (
        <div className="no-content-img">
          <Lottie style={style} loop={true} animationData={NotFound} />
          <span className="no-content-text">No Outlets!!</span>
        </div>
      ) : null}
      <TwoBtnModal
        isOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCloseModal}
        message={{ title: "", text: "Do you want to exit the Application?" }}
        icon=""
        className=""
        showCancelButton={true} 
      />
      <Footer />
    </div>
  );
};

export default RestaurantList;
